import { render, staticRenderFns } from "./GroupUsersTable.vue?vue&type=template&id=40a8cf48&"
import script from "./GroupUsersTable.vue?vue&type=script&lang=js&"
export * from "./GroupUsersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports